import PropTypes from 'prop-types';
import React from 'react';

import IfmsButton, { IfmsButtonProps } from './IfmsButton';

const HighlightButton = React.forwardRef<HTMLButtonElement, IfmsButtonProps>(({ children, useInList, ...other }, ref) => {
  let baseClass = 'ifms-highlight-button'
  if (useInList) baseClass = ' ifms-highlight-button-icon'
  return (
    <IfmsButton ref={ref} {...other} baseClass={baseClass}>
      {children}
    </IfmsButton>
  );
});

HighlightButton.defaultProps = {
};

HighlightButton.propTypes = {
  size: PropTypes.oneOf(['regular', 'small', 'large', 'extrasmall']),
};

export default React.memo(HighlightButton);

